import { IconProps } from "@/utils/types";

function CloseIcon({ color = "#6F6C90", style }: IconProps) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M2 16.1626L16.5708 1.5918"
        stroke={color}
        strokeWidth="2.4372"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5708 16.1626L2 1.5918"
        stroke={color}
        strokeWidth="2.4372"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default CloseIcon;
